import VueI18n from "vue-i18n"
import { Store } from "vuex"

import { AdminTemplateModuleStore } from "../../store/StoreTypes"

export const i18nHelper = {
  defaultLocaleSet: false,

  initLocale: function(i18n: VueI18n, store: Store<{ AdminTemplate: AdminTemplateModuleStore }>){
    if (!this.defaultLocaleSet) {
      const cacheLocale = this.getLocalStorageLocale()
      const userLangOrBrowser = store.getters['AdminTemplate/userLangOrBrowser']

      if (cacheLocale) {
        this.setLocale(i18n, cacheLocale)
      } else {
        if (userLangOrBrowser) {
          this.setLocale(i18n, userLangOrBrowser)
        }
      }

      this.defaultLocaleSet = true
    }
  },
  setLocale(i18n: VueI18n, locale: string) {
    i18n.locale = locale
  },
  getLocalStorageLocale() {
    return localStorage && localStorage.getItem('locale')
  },
  setLocalStorageLocale(locale: string) {
    if (localStorage) {
      localStorage.setItem('locale', locale)
    }
  },
}
